module.exports = __webpack_public_path__ + "static/media/blob-shape-4.af13d39d.svg";